import React from 'react'

function TechSelectClassic() {
  return (
    <embed src="\pdfs\E1.3.1_mfu_classic_1x1-f6_h13_07.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectClassic